var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReddeletebtnsvg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 18,
    viewBox: "0 0 16 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.90865 6.375L9.62019 13.875M5.62981 13.875L5.34135 6.375M1.60196 3.70047C2.55731 3.5562 3.52374 3.44571 4.5 3.37027C5.5312 3.29058 6.57336 3.25 7.625 3.25C8.67664 3.25 9.7188 3.29058 10.75 3.37027C11.7263 3.44571 12.6927 3.5562 13.648 3.70047C13.933 3.74351 14.217 3.78956 14.5 3.83858M13.648 3.70047L12.7582 15.2688C12.683 16.2457 11.8684 17 10.8887 17H4.36131C3.38155 17 2.56698 16.2457 2.49183 15.2688L1.60196 3.70047M0.75 3.83858C1.03298 3.78956 1.31698 3.74351 1.60196 3.70047M10.75 3.37027V2.60682C10.75 1.62402 9.99112 0.803526 9.00882 0.772103C8.54935 0.757405 8.08804 0.75 7.625 0.75C7.16196 0.75 6.70065 0.757405 6.24118 0.772103C5.25888 0.803526 4.5 1.62402 4.5 2.60682V3.37027",
    stroke: "#FF5757",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReddeletebtnsvg);
export default __webpack_public_path__ + "static/media/reddeletebtnsvg.6b752d28b3340fac7e792d087312356a.svg";
export { ForwardRef as ReactComponent };